<template>
  <div :class='["headerbox",focus=="0" ? "headerbox1" : ""]'>
    <div class="left">
      <img src="../../public/statics/img/logo.png" alt="">
    </div>
    <div class="middle">
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(0)">
        首页
        <div v-show="focus==0" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(1)">
        申请加入
        <div v-show="focus==1" class="middlesfocus2"></div>
        <div v-show="focus==6" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(2)">
        支持中心
        <div v-show="focus==2" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(3)">
        资讯动态
        <div v-show="focus==3" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(4)">
        客服中心
        <div v-show="focus==4" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(5)">
        生态云商城
        <div v-show="focus==5" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(7)">
        云货主App
        <div v-show="focus==7" class="middlesfocus1"></div>
      </div>
      <div :class="focus==1? 'middlesblack':'middles'" @click="jumppage(8)">
        云车主App
        <div v-show="focus==8" class="middlesfocus1"></div>
      </div>
    </div>
    <div class="right">

      <div :class="focus==1? 'rightsos':'rightso'" v-if="status==1">
        <div style="display: flex;">
                   <span style="white-space:nowrap;
   text-overflow:ellipsis;
   overflow:hidden;
   max-width:1rem;
   display:block;margin-right: 5px;">{{ name }}</span>
          <span @click="logout()">退出</span>
        </div>
        <div class="rightso1">
          <span @click="jumplogistics()">登录云端</span>
        </div>
      </div>
      <div :class="focus==1? 'rightss':'rights'" v-else>
        <div>
          <span @click="showpsshow()">登录</span>
        </div>
        <div>
          /
        </div>
        <div>
          <span @click="jumplogistics()">登录云端</span>
        </div>

      </div>
      <el-form ref="form" :model="form" style="width: 100%" :rules="rules" @keyup.enter.native="addByEnterKey">
        <div v-show="psshow" class="login_son_box">
          <div class="chahao" @click="psshow=false">X</div>
          <div class="center">
            <div class="center_img">
              <p>用户登录</p>
            </div>
            <div class="input_up">
              <div class="input_up_style">
                <p><span>*</span>手机号:</p>
                <el-form-item prop="phone" style="height: 100%">
                  <el-input v-model="form.phone" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
              <!--   <div class="input_up_style">
                  <p><span>*</span>密码:</p>
                  <el-form-item prop="password" style="height: 100%">
                      <el-input type="password" v-model="form.password"
                                show-password
                                placeholder="请输入"></el-input>
                  </el-form-item>
              </div>-->
              <div class="input_up_style">
                <p><span>*</span>验证码:</p>
                <el-form-item prop="code" style="height: 100%;">
                  <div style="display: flex;justify-content: space-between;">
                    <el-input type="code" v-model="form.code"
                              style="width:220px;"
                              placeholder="请输入"></el-input>
                    <el-button v-show="shows==true" type="primary"
                               style="width: 100px;padding: 0 10px;" @click="getcode()">获取验证码
                    </el-button>
                    <el-button v-show="shows==false" type="primary"
                               style="width: 100px;padding: 0 10px;">{{ count }}秒
                    </el-button>
                  </div>


                </el-form-item>
              </div>
              <div class="input_up_style1">
                <div>
                  <i class="el-icon-info"></i>
                  <p>推荐使用谷歌浏览器</p>
                </div>
                <!--<span @click="">忘记密码?</span>-->
              </div>

              <el-button type="primary" @click="submitForm" class="loginstyle">登录
              </el-button>


            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
const TIME_COUNT = 60;
import {auth, loginauth, anth} from '../request/api';
import Cookies from 'js-cookie'
import {getToken, setToken, removeToken} from '../request/toekn'
import {mapGetters} from "vuex";

export default {
  name: "boxtop",
  props: {
    focus: Number
  },
  computed: {
    ...mapGetters(["name", "avatar", "companyname", "phone", "password"]),
  },
  data() {
    return {
      loading: false,
      //登录表单
      form: {
        phone: '',
        password: '',
        code: '',
        point_type:1,
      },
      //登录验证
      rules: {
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'},
        ],
        /*  password: [
              {required: true, message: '请输入密码', trigger: 'blur'},
              {min: 6, max: 20, message: '长度在 6 到 20 位字符', trigger: 'blur'}
          ],*/
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ],

      },
      //展示
      psshow: false,
      //登录状态
      status: 0,
      count: "",
      shows: true,
    }
  },
  created() {
    if (Cookies.get(getToken()) && getToken()) {
      this.status = 1;
      this.getuserinfo()
    }
  },
  mounted() {
  },
  methods: {

    //标签页
    jumppage(e) {

      if (e == 0) {
        this.$router.push({path: '/index',});
      } else if (e == 1) {
        this.$router.push({path: '/edition',});
        /* if (Cookies.get(getToken()) && getToken()) {
             this.$router.push({path: '/edition',});
         } else {
             this.$router.push({path: '/apply',});
         }*/
      } else if (e == 2) {
        this.$router.push({path: '/word',});
      } else if (e == 3) {
        this.$router.push({path: '/newviews',});
      } else if (e == 4) {
        this.$router.push({path: '/chat',});

        // window.open('https://tb.53kf.com/code/client/daa8b04cbb02352f2449873bb79aebfa8/1', '_blank');
      } else if (e == 5) {

        this.$router.push({path: '/shop',});

        // window.open('https://tb.53kf.com/code/client/daa8b04cbb02352f2449873bb79aebfa8/1', '_blank');
      } else if (e == 7) {
        this.$router.push({path: '/cargoOwner',});
      } else if (e == 8) {
        this.$router.push({path: '/carOwner',});
      }
    },
    //显示登录列表
    showpsshow() {
      this.psshow = true;
    },
    addByEnterKey(e) {
      //Enter键的代码就是13
      if (e.keyCode == 13) {
        this.submitForm();
      }
    },

    getuserinfo() {
      this.$store.dispatch('GetInfo').then(data => {
        // console.log('成功')
      }).catch((data) => {
        if (data.data.code == 8000) {
          this.logout();
          this.loading = false;
        } else {
          this.$message.error(data.data.msg);
          this.loading = false;
          return false;
        }
      })
    },
    //登录表单提交
    submitForm(form) {
      // this.loading = true;
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let code = {
            phone: this.form.phone, //手机号
            code: this.form.code, //公司编号
            // password: this.form.password, //密码
            type: 1,
            point_type:this.form.point_type,
          };
          Cookies.remove();
          removeToken();

          this.$store.dispatch('Login', code).then(data => {
            this.loading = false;
            if (Cookies.get(getToken()) && getToken()) {

              loginauth().then(res => {
                if (res.data.code == 1) {

                  let menus = res.data.data.menu;
                  if (menus != '') {
                    if (menus.user) {
                      Lockr.set('user', menus.user.children);
                    }
                    if (menus.transport) {
                      Lockr.set('transport', menus.transport.children);
                    }
                    if (menus.packing) {
                      Lockr.set('packing', menus.packing.children);
                    }
                    if (menus.storage) {
                      Lockr.set('storage', menus.storage.children);
                    }
                  }

                  let buttonauth=res.data.data.auth_code;
                  Lockr.set('authbuttons',buttonauth);
                  let wordobj={
                    transportword:res.data.data.yunshu,
                    packingword:res.data.data.baozhuang,
                    storeword:res.data.data.cangchu
                  };
                  let videoauth = {
                    transportvideo: res.data.data.video_menu.transport,
                    packingvideo: res.data.data.video_menu.packing,
                    storevideo: res.data.data.video_menu.storage,
                  }
                  Lockr.set('videoauths', videoauth);
                  Lockr.set('wordauth',wordobj);

                  this.getuserinfo();
                  this.$message({
                    type: 'success',
                    message: '登录成功'
                  });
                  this.status = 1;
                  this.$router.push({path: '/index',});
                  this.psshow = false;

                } else {
                  this.$message({
                    type: 'error',
                    message: res.data.msg
                  });
                  setTimeout(() => {
                    this.logout();
                  }, 500);
                  return;
                }
              });

            }
          }).catch((data) => {
            // this.$message.error(data);


            if (data.code==8102){
              this.$confirm(data.msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.form.point_type=2;
                this.submitForm();
              })
            }else{
              this.$message({
                type: 'error',
                message: data.msg
              });
            }
            this.loading = false
          })
        } else {
          console.log('error submit!!');
          return false;

        }
      });

    },
    // 退出登录
    logout() {
      this.$store.dispatch('LogOut').then(data => {
        this.$message({
          type: 'success',
          message: '退出成功',
        });
        this.status = 0;
        this.$router.push({path: '/index',});
      }).catch((data) => {
        this.$message.error(data.data.msg);
        this.loading = false;
      })
    },
    //进入系统
    jumplogistics() {
      // console.log(this.phone);
      // return;
      if (Cookies.get(getToken()) && getToken()) {
        //判断是否能跳转各大中心
        if (Lockr.get("transport")) {
          Cookies.set('cate', 1)
          window.location.replace(window.idomain)//正式环境
          return;
        }
        if (Lockr.get("storage")) {
          Cookies.set('cate', 5)
          window.location.replace(window.idomains)//正式环境
          return;
        }
        if (Lockr.get("packing")) {
          Cookies.set('cate', 2)
          window.location.replace(window.idomains)//正式环境
          return;
        }

      } else {
        window.location.replace(window.idomain)//正式环境
      }

    },
    //获取验证码
    getcode() {
      if (this.form.phone == undefined || this.form.phone == '') {
        this.$message({
          type: "warning",
          message: "请先输入手机号"
        })
      } else {
        let url = '/v1/member/login/send_sms';
        let data = {
          phone: this.form.phone,
          type: 1,
        };
        auth(url, data).then(res => {
          if (res.data.code == 1) {
            this.$message({
              type: "success",
              message: "发送成功"
            })
            this.count = TIME_COUNT;
            this.shows = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.shows = true;
                clearInterval(this.timer);  // 清除定时器
                this.timer = null;
              }
            }, 1000)
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      }

    },
  },
}
</script>

<style scoped lang='scss'>
.headerbox {
  position: fixed;
  z-index: 999;
  top: 0;
  width: 100%;
  height: 0.6rem;
  /*background: antiquewhite;*/
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    /*width: 2rem;*/
    height: 0.48rem;
    margin-left: 0.5rem;

    img {
      /*width: 100%;*/
      height: 100%;
    }
  }

  .middle {
    display: flex;

    .middles {
      width: 1.5rem;
      font-family: "PingFang SC";
      font-size: 0.2rem;
      cursor: pointer;
      color: #fff;
      position: relative;
    }

    .middlesfocus1 {
      display: block;
      content: "";
      position: absolute;
      width: 0.25rem;
      height: 0.04rem;
      background: #fff;
      left: 0;
      right: 0;
      bottom: -0.12rem;

      margin: auto;
      border-radius: 2px;
    }

    .middlesblack {
      width: 1.5rem;
      font-family: "PingFang SC";
      font-size: 0.2rem;
      cursor: pointer;
      color: #333;
      position: relative;
    }

    .middlesfocus2 {
      display: block;
      content: "";
      position: absolute;
      width: 0.25rem;
      height: 0.04rem;
      background: #333;
      left: 0;
      right: 0;
      bottom: -0.12rem;
      margin: auto;
      border-radius: 2px;
    }

  }

  .right {
    position: relative;
    margin-right: 40px;
    font-family: "PingFang SC";

    .rights {
      width: 1.8rem;
      height: 0.4rem;
      display: flex;
      border: 2px solid #ffffff;
      color: #ffffff;
      justify-content: space-around;
      align-items: center;
      font-size: 0.18rem;
      border-radius: 60px;
      padding: 0 10px;

      span {
        cursor: pointer;
        text-align: center;
        line-height: 0.4rem;
      }
    }

    .rightss {
      width: 1.8rem;
      height: 0.4rem;
      display: flex;
      border: 2px solid #777;
      color: #333;
      justify-content: space-around;
      align-items: center;
      border-radius: 60px;
      font-size: 0.18rem;
      padding: 0 10px;

      span {
        cursor: pointer;
        text-align: center;
        line-height: 0.4rem;
      }
    }

    .rightso {
      width: 3rem;
      height: 0.4rem;
      display: flex;
      color: #ffffff;
      justify-content: space-around;
      align-items: center;
      font-size: 0.18rem;

      .rightso1 {
        width: 1.2rem;
        height: 0.4rem;
        line-height: 0.4rem;
        border: 2px solid #ffffff;
        border-radius: 60px;


      }

      span {
        cursor: pointer;
      }
    }

    .rightsos {
      width: 3rem;
      height: 0.4rem;
      display: flex;
      color: #333;
      justify-content: space-around;
      align-items: center;
      font-size: 0.18rem;

      .rightso1 {
        width: 1.2rem;
        height: 0.4rem;
        line-height: 0.4rem;
        border: 2px solid #777;
        border-radius: 60px;

      }

      span {
        cursor: pointer;
      }
    }

    .login_son_box {
      position: absolute;
      top: 60px;
      right: 20px;
      margin: auto;
      width: 380px;
      height: 390px;
      background: rgba(255, 255, 255, 1);
      box-shadow: -1px 1px 35px -3px rgba(0, 0, 0, 0.15);
      -webkit-box-shadow: -1px 1px 35px -3px rgba(0, 0, 0, 0.15);
      -moz-box-shadow: -1px 1px 35px -3px rgba(0, 0, 0, 0.15);
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .chahao {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 16px;
        cursor: pointer;
        z-index: 9999;
      }

      .registerstyle {
        width: auto;
        height: auto;
        font-size: 20px;
        cursor: pointer;
        margin: 20px 0 0 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #4597FF;
      }

      .center {
        width: 100%;
        height: auto;
        padding: 0 20px 0 20px;
        box-sizing: border-box;
        margin-top: 6px;

        .center_img {
          width: 100%;
          height: 39px;
          display: flex;
          /*margin-bottom: 11px;*/
          justify-content: center;
          margin: 30px 0 10px;

          p {
            width: auto;
            height: 50px;
            font-size: 30px;
            font-family: 'PingFang SC';
            /*font-weight: bold;*/
            line-height: 41px;
            color: #2B2C44;
          }
        }

        .input_up {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .input_up_style {
            height: 94px;
            display: flex;
            flex-direction: column;

            p {
              font-size: 14px;
              font-family: "PingFang SC";
              line-height: 24px;
              color: #606266;
              text-align: left;

              span {
                color: #F35959;
                margin-right: 5px;
              }
            }
          }

          .input_up_style1 {
            height: 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            div {
              display: flex;

              i {
                font-size: 16px;
                color: #FBA962;
                line-height: 20px;
              }

              p {

                font-size: 14px;
                font-family: "PingFang SC";
                color: #606266;
                line-height: 20px;
              }
            }

            span {
              font-size: 14px;
              line-height: 20px;
              font-family: "PingFang SC";
              color: #3D68EB;
              cursor: pointer;
            }

          }

          .loginstyle {
            width: 100%;
            height: 52px;
            padding: 0 10px;
            font-size: 16px;
            cursor: pointer;
            margin-top: 20px;
          }
        }

        .center_bottom {
          width: 100%;
          height: 16px;
          margin-top: 50px;
          display: flex;
          justify-content: space-between;

          .jump-icon {
            background: #666;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 14px;
            height: 14px;
            font-size: 10px;
            color: #fff;
            margin-right: 5px;
          }

          .jump-bar {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #595959;
            padding-right: 10px;
            cursor: pointer;
          }

          .jump-bar:hover {
            color: #66B1E1;
          }
        }
      }

    }

  }


}

.headerbox1 {
  background: #005f88;
}
</style>
